import withListarTemasArea from "../../hoc/Docentes/withListarTemasAreas"
import TemasDisponibles from "../../view/components/RegistroUsuarios/Clasificacion/EditarTemasArea/TemasDisponibles"
import withInsertarTemasDocente from "../../hoc/Docentes/withInsertarTemasDocente"


export default withInsertarTemasDocente(withListarTemasArea(TemasDisponibles))